import type {
  ChannelShiftDayRequestAdmin,
  ChannelShiftDayPeriodRequestAdmin,
  DayOfWeek,
  PutChannelManualStatusRequestAdmin,
  PutChannelShiftsRequestAdmin
} from '@/backend/market'
import { ChannelAvailabilityStatus } from '@/backend/market'
import type {
  ChannelShiftEntity,
  ChannelShiftPeriodEntity
} from '../../domain/entities/ChannelWorkingHoursEntity'

function normalizeTime(time?: string): string {
  if (!time) return '00:00:00'
  return time.length === 5 ? `${time}:00` : time
}

function periodToRequest(period: ChannelShiftPeriodEntity): ChannelShiftDayPeriodRequestAdmin {
  return {
    id: period.id ?? null,
    startTimeDayOfWeek: period.startTimeDayOfWeek as DayOfWeek,
    startTime: normalizeTime(period.startTime),
    endTimeDayOfWeek: period.endTimeDayOfWeek as DayOfWeek,
    endTime: normalizeTime(period.endTime),
    status: period.status!
  }
}

export function toPutChannelShiftsRequest(
  shiftDays: ChannelShiftEntity[]
): PutChannelShiftsRequestAdmin {
  const request: ChannelShiftDayRequestAdmin[] = shiftDays.map((day) => ({
    dayOfWeek: day.dayOfWeek,
    overallShiftStatus: day.overallShiftStatus!,
    periods: (day.periods ?? []).map(periodToRequest)
  }))

  return { shiftDays: request }
}

export function toPutChannelManualStatusRequest(
  status: PutChannelManualStatusRequestAdmin['status'],
  expiresAt: string | null
): PutChannelManualStatusRequestAdmin {
  return {
    status,
    expiresAt: status === ChannelAvailabilityStatus.CLOSED ? expiresAt : null
  }
}
